import { render } from "./table-form.vue?vue&type=template&id=020fffd4&lang=html"
import script from "./table-form.vue?vue&type=script&lang=js"
export * from "./table-form.vue?vue&type=script&lang=js"

import "./table-form.vue?vue&type=style&index=0&id=020fffd4&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__